import { render, staticRenderFns } from "./block-profile-data.vue?vue&type=template&id=6144ad86&scoped=true&lang=pug"
import script from "./block-profile-data.vue?vue&type=script&lang=js"
export * from "./block-profile-data.vue?vue&type=script&lang=js"
import style0 from "./block-profile-data.vue?vue&type=style&index=0&id=6144ad86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144ad86",
  null
  
)

export default component.exports